import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch, useSelector } from 'react-redux';
import { Typography, Button, Link } from '@mui/material';
import { alertActions, masterActions, registrationActions, userActions } from '_store';
import { registerValidationSchema } from '_utils/validationSchema';
import { PersonalDetails } from 'container/user';
import { ModalPopup } from '_components';
import Grid from "@material-ui/core/Grid";
import { aggrementEALabel, genericlabels, verifyEmailLabels } from '_utils/labels';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import EARegistrationPopup from './EARegistrationPopup';
import TimerModal from '_components/TimerModal';
import { ERR_MSG } from 'constants/labels';
const Register = () => {
    const header = "Registration";
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isPasswordValid, setIsPasswordValid] = useState(false);
    const [openAgreeModal, setOpenAgreeModal] = useState(false);
    const [eaData, setEAData] = useState(null);
    const [isAgreed, setIsAgreed] = useState(false);
    const portals = useSelector((x) => x.master?.portalData);
    const excludedPortalIds = [];
    const renderTextWithEmailLink = (text) => {
        if (!text) return null;
        const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
        const parts = text.split(emailRegex);
        return parts.map((part, i) =>
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(part) ? (
                <a key={i} href={`mailto:${part}`} style={{ color: '#1976D2' }}>{part}</a>
            ) : (
                <span key={i}>{part}</span>
            )
        );
    };

    const renderContactSection = (text) => {
        if (!text) return null;
        const entries = text.split(/\r?\n/).map(e => e.trim()).filter(Boolean);

        if (entries.length <= 1) {
            return (
                <p style={{ margin: '6px 0 0' }}>
                    <strong>Contact:</strong> {renderTextWithEmailLink(entries[0] || text)}
                </p>
            );
        }

        return (
            <div style={{ margin: '6px 0 0' }}>
                <strong>Contact:</strong>
                <ul style={{ margin: '4px 0 0', paddingLeft: '18px' }}>
                    {entries.map((entry, i) => (
                        <li key={i} style={{ marginBottom: '2px' }}>
                            {renderTextWithEmailLink(entry)}
                        </li>
                    ))}
                </ul>
            </div>
        );
    };

    const portalData = (!portals?.loading && !portals?.error)
        ? portals
            ?.filter(x => !excludedPortalIds.includes(x.PortalID))
            .map(x => ({
                label: x.PortalName,
                value: x.PortalID,
                description: (x.PortalInfo || x.SupportEmail) ? (
                    <div>
                        {x.PortalInfo && <p style={{ margin: 0 }}>{x.PortalInfo}</p>}
                        {renderContactSection(x.SupportEmail)}
                    </div>
                ) : null,
            }))
        : [];

    const [showTimerModal, setShowTimerModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [showAlreadyRegistered,setShowAlreadyRegistered] = useState(false);
    const [showPortalRedirectPopup, setShowPortalRedirectPopup] = useState(true);
    const { register, handleSubmit, control, formState: { errors, isValid }, watch, trigger, resetField } = useForm({
        resolver: yupResolver(registerValidationSchema),
        mode: 'onChange',
        defaultValues: {
            PortalId: null,
        },
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                dispatch(alertActions.clear());
                dispatch(masterActions.getPortalData());
            } catch (error) {
                dispatch(alertActions.error({
                    message: error.message ? ERR_MSG["073"] : error,
                    header: "Fetch Failed"
                }));
            }
        };
        fetchData();
    }, [dispatch]);

    const handleClosed = () => {
        setShowTimerModal(false);
        navigate('/register');
    }
    const handleClick = () => {
        setShowTimerModal(false);
        navigate('/');

    }
    const onSubmit = async (data) => {
        const portalKey = portals?.find(p => p.PortalID === data.PortalId)?.PortalKey;
        if (portalKey && portalKey.toLowerCase() === 'ea' && !isAgreed) {
            setEAData(data);
            setOpenAgreeModal(true);
            return;
        }
        handleRegister(data);
    };

    const handleRegister = async (data) => {
        dispatch(alertActions.clear());
        try {
            await dispatch(registrationActions.register(data)).unwrap();
            navigate('/');
            dispatch(alertActions.success({
                showAfterRedirect: true,
                message: verifyEmailLabels.message1,
                header: verifyEmailLabels.header
            }));
        } catch (error) {
            if (error.message) {
              dispatch(
                alertActions.error({
                  message: ERR_MSG["073"],
                  header: "Registration Failed",
                }),
              );
              return;
            }
            if (error === "Email address already registered") {
              setShowAlreadyRegistered(true);
            }
            setShowTimerModal(true);
            setErrorMessage(error);
        }
    }

    const handleClose = () => {
        setOpenAgreeModal(false);
        setIsAgreed(false);
    };

    const handleConfirmClick = async () => {
        await setOpenAgreeModal(false);
        await setIsAgreed(true);
        handleRegister(eaData);
    };

    return (
        <Typography component="div" className="Registrationcontainerlist">
            <Typography component="h1" variant="h5" className="Logincontent">Registration</Typography>
            <form onSubmit={handleSubmit(onSubmit)} className='Registrationcontainer' autoComplete="off" method="post">
                <PersonalDetails
                    isPasswordValid={isPasswordValid}
                    register={register}
                    errors={errors}
                    watch={watch}
                    control={control}
                    resetField={resetField}
                    trigger={trigger}
                    setIsPasswordValid={setIsPasswordValid}
                    portalData={portalData}
                    portalList={portals}
                    setIsAgreed={setIsAgreed}
                />
                <Typography component="div" className="loginbuttonfixed">
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        className='Loginbutton'
                        color="primary"
                        disabled={!isValid || !isPasswordValid}
                    >
                        Register
                    </Button>
                    <Grid container>
                        <Grid item className="accountSignup">
                            <div>Do you already have an account? </div>
                            <Link component={RouterLink} to="/" variant="body2">
                            Login here
                            </Link>
                        </Grid>
                    </Grid>

                </Typography>

            </form>
            {openAgreeModal && <EARegistrationPopup
                header={aggrementEALabel.header}
                message1={aggrementEALabel.message1}
                btnPrimaryText={aggrementEALabel.btnPrimaryText}
                btnSecondaryText={aggrementEALabel.btnSecondaryText}
                handlePrimaryClick={handleConfirmClick}
                handleSecondaryClick={handleClose}
            />}

            {(showTimerModal || showAlreadyRegistered) &&
                <ModalPopup
                    header={`Registration Failed`}
                    message1={errorMessage}
                    errors={true}
                    btnPrimaryText={`Close`}
                    btnSecondaryText={`Login`}
                    handlePrimaryClick={() => handleClosed()}
                    handleSecondaryClick={() => handleClick()}
                    className="verifiedRegistrationpopup"
                />
            }

            {showPortalRedirectPopup && (
                <ModalPopup
                    header="Looking to Manage Your Washington Gas Account?"
                    message1={
                        <div style={{ fontFamily: '"Proxima Nova Rg"', fontSize: '16px', fontWeight: 400, lineHeight: '28px', color: '#4D4C52', letterSpacing: '0.15px' }}>
                            <p>Register on our <a href="https://my.washingtongas.com/portal/" target="_blank" rel="noopener noreferrer">Customer Portal</a> to:</p>
                            <ul>
                                <li>View and print your Washington Gas bill on demand (up to 12 months)</li>
                                <li>Pay your bill using your credit/debit card or checking account</li>
                                <li>Enroll in the Budget Billing, <a href="https://www.washingtongas.com/billing-and-payment/billing/ebill" target="_blank" rel="noopener noreferrer">eBill</a> and/or Auto-Pay programs</li>
                                <li>Check your account balance</li>
                                <li>View your billing and payment history</li>
                                <li>Monitor your energy usage with month-to-month usage comparisons</li>
                            </ul>
                        </div>
                    }
                    btnPrimaryText="CONTINUE TO CUSTOMER PORTAL"
                    btnSecondaryText="CANCEL"
                    handleSecondaryClick={() => setShowPortalRedirectPopup(false)}
                    handlePrimaryClick={() => {
                        window.open('https://my.washingtongas.com/portal/', '_blank', 'noopener,noreferrer');
                        setShowPortalRedirectPopup(false);
                    }}
                />
            )}

        </Typography>
    );
};

export default Register;